import {
	IconGratuityLevel1,
	IconGratuityLevel2,
	IconGratuityLevel3
} from '../components';
import {VueComponent} from '../types';

type TGratuityIcon = VueComponent;
export type TMaybeGratuityIcon = TGratuityIcon | null;

export interface IGratuity {
	amount: number;
	icon: TMaybeGratuityIcon;
	label?: string;
}

class Gratuity {
	static readonly PERCENTAGE_THRESHOLD = 1000;

	private static readonly ICONS: VueComponent[] = [
		IconGratuityLevel1,
		IconGratuityLevel2,
		IconGratuityLevel3,
	];

	private static readonly PERCENTAGES: IGratuity[] = [
		{
			amount: 0.15,
			icon: Gratuity.ICONS[0],
			label: '15%',
		},
		{
			amount: 0.20,
			icon: Gratuity.ICONS[1],
			label: '20%',
		},
		{
			amount: 0.25,
			icon: Gratuity.ICONS[2],
			label: '25%',
		},
	];

	private static readonly FIXED_AMOUNTS: IGratuity[] = [
		{
			amount: 100,
			icon: Gratuity.ICONS[0],
		},
		{
			amount: 200,
			icon: Gratuity.ICONS[1],
		},
		{
			amount: 300,
			icon: Gratuity.ICONS[2],
		},
	];

	determineIcon(subtotal: number, gratuity: number): TMaybeGratuityIcon {
		let gratuities: IGratuity[];
		let targetValue = gratuity;

		if(subtotal > Gratuity.PERCENTAGE_THRESHOLD) {
			gratuities = Gratuity.PERCENTAGES;
			targetValue = gratuity / subtotal;
		} else {
			gratuities = Gratuity.FIXED_AMOUNTS;
		}

		// find the closest, fixed amount
		// iterate in reverse order in case gratuity exceeds highest amount
		for(let i = gratuities.length - 1; i >= 0; i--) {
			if(targetValue >= gratuities[i].amount) {
				return gratuities[i].icon;
			}
		}

		// If at least some tip was given, use the level 1 image, but judge them very harshly.
		if(gratuity > 0) {
			return Gratuity.ICONS[0];
		}

		return null;
	}

	/**
	 * provides suggested gratuity amounts based on subtotal
	 *
	 * subtotal should not include tax.
	 *
	 * @param subtotal
	 */
	getSuggestions(subtotal: number): IGratuity[] {
		if(subtotal > Gratuity.PERCENTAGE_THRESHOLD) {
			return [...Gratuity.PERCENTAGES].map(gratuity => ({
				...gratuity,
				amount: Math.round(subtotal * gratuity.amount),
			}));
		} else {
			return [...Gratuity.FIXED_AMOUNTS];
		}
	}
}

export const GratuityService = new Gratuity();
